<template>
  <div class="container">
    <LineChart
      v-if="loaded"
      :chartdata="chartdata"
      :options="options"
      :styles="myStyles"
      />
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'

export default {
  name: 'CsatChartClient',
  components: { LineChart },
  data() {
  return {
    loaded: true,
    chartdata: {
      labels: ['January', 'February', 'March'],
      datasets: [
        {
          label: 'Customer Satisfaction Score',
          data: [3.5, 4.2, 4.5]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
    }
   }
   },
   computed: {
    myStyles () {
      return {
        height: `190px`,
        position: 'relative'
      }
    }
  }
// -------------------- Chart with API data --------------------- //
//   data: () => ({
//     loaded: false,
//     chartdata: null
//   }),
//   async mounted () {
//     this.loaded = false
//     try {
//       const { userlist } = await fetch('/api/userlist')
//       this.chartdata = userlist
//       this.loaded = true
//     } catch (e) {
//       console.error(e)
//     }
//   }
}
</script>

<style lang="scss" scoped>

</style>